import React from 'react'
import Avatar from '../../Avatar'
import TableTags from '../../List/TableTags'

const AvatarTagsRenderer = ({ item, def, color }) => {
  const getAvatar = item[def.column][0]
  const getTags = item[def.tags]
  return (
    getAvatar?.firstName ?
      <Avatar color={color} firstName={getAvatar.firstName} lastName={getAvatar.lastName} showName />
      :
      <TableTags colorClassName={color} tags={getTags} />
  )
}

export default AvatarTagsRenderer